import React, { useState, useEffect, useContext } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import useAwaitableComponent from "use-awaitable-component";
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import queryString from "query-string"

import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
  InputAdornment,
  FormControl,
  FormHelperText,
} from '@material-ui/core';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"

import LanguageContext from "../contexts/LanguageContext"
import { renewSocket } from "../contexts/SocketContext"

import MyMiniModal from "../components/ui/MyMiniModal"
import rectBlackCheckWhite from "../images/rectBlackCheckWhite.svg"

const RegisterAdmin = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues, changeLanguage } = useContext(LanguageContext)

  const [showPassword, setShowPassword] = useState(false)

  const [alertMessage, setAlertMessage] = useState()

  const [status, execute, resolve, reject, reset] = useAwaitableComponent();
  const showModal = status === "awaiting";

  const [id, setId] = useState(null)
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [isValidRequest, setIsValidRequest] = useState(null)
  useEffect(() => {
    const urlParams = queryString.parse(window.location.search)
    window.history.replaceState(null, null, window.location.pathname)
    if (urlParams.lg && (urlParams.lg === "en" || urlParams.lg === "fr")) {
      changeLanguage(urlParams.lg)
    }
    if (urlParams.i && urlParams.mail && urlParams.lg && urlParams.invit === "yes") {
      APIS.checkAdminRegister(urlParams).then(result => {
        if (result.isOk === true && result.data) {
          setId(urlParams.i)
          setName(result?.data.name)
          setEmail(result?.data.email)
          setIsValidRequest(true)
        } else {
          setIsValidRequest(false)
        }
      })
    } else {
      setIsValidRequest(false)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>{languageValues?.registerPage?.pageTitle[actLanguage] || ''} | TheLab</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >

        {isValidRequest &&
          <Container maxWidth="sm">
            <Formik
              initialValues={{
                name : name ? name : '',
                email: email ? email : '',
                password: '',
                checkRules: false,
              }}
              validationSchema={Yup.object().shape({
                name: Yup.string().min(3, `${languageValues?.requiredField[actLanguage]}`).max(255, `${languageValues?.requiredField[actLanguage]}`).required(`${languageValues?.requiredField[actLanguage]}`),
                email: Yup.string().email(`${languageValues?.requiredField[actLanguage]}`).max(255).required(`${languageValues?.requiredField[actLanguage]}`),
                password: Yup.string().min(8, `${languageValues?.requiredField[actLanguage]}`).max(255, `${languageValues?.requiredField[actLanguage]}`).required(`${languageValues?.requiredField[actLanguage]}`),
                checkRules : Yup.bool().oneOf([true], `${languageValues?.requiredField[actLanguage]}`)
              })}
              onSubmit={async (values, { setSubmitting }) => {
                setAlertMessage("");
                try {
                  const value = await execute();

                  const register = await APIS.adminRegister({id : id, password : values.password, language : actLanguage})
                  if (register?.isOk === true) {
                    const userData = {
                      email:  values?.email?.trim()?.toLowerCase(),
                      password: values.password,
                      language : actLanguage,
                    }
                    APIS.loginUser(userData).then(result => {
                      if (result?.message === "signin" && result?.user) {
                        setUser(result?.user)
                        renewSocket()
                        navigate("/")
                        return
                      } else {
                        setAlertMessage(languageValues?.loginPage?.incorrectMessage[actLanguage])
                      }
                    })
                  } else {
                    alert("Error")
                  }

                } catch (err) { console.log(err) } finally {
                  reset();
                }

              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box sx={{ mb: 2, textAlign:"center" }}>
                    <Typography
                      color="text.blackTitle"
                      variant="h2"
                    >
                      {languageValues?.onBoarding?.title[actLanguage]}
                    </Typography>
                  </Box>

                  <Box sx={{textTransform:"uppercase", fontSize:["12px", "15px"], color:"text.black"}}>
                    {languageValues?.myAccount?.name[actLanguage]}
                  </Box>
                  <TextField
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    margin="normal"
                    name="name"
                    type="text"
                    value={values.name}
                    disabled
                    onBlur={handleBlur}
                    onChange={handleChange}
                    variant="outlined"
                    sx={{
                      marginTop:"10px",
                    }}
                  />

                  <Box sx={{textTransform:"uppercase", fontSize:["12px", "15px"], paddingTop:"10px",}}>
                    {languageValues?.loginPage?.emailField[actLanguage]}
                  </Box>
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    margin="normal"
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="email"
                    value={values.email}
                    variant="outlined"
                    disabled
                  />
                  <Box sx={{textTransform:"uppercase", fontSize:["12px", "15px"], paddingTop:"10px",}}>
                    {languageValues?.loginPage?.passwordField[actLanguage]}
                  </Box>
                  <TextField
                    error={Boolean(touched.password && errors.password)}
                    fullWidth
                    helperText={touched.password && errors.password}
                    margin="normal"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type={showPassword ? "text" : "password"}
                    value={values.password}
                    variant="outlined"
                    placeholder={languageValues?.loginPage?.passwordField[actLanguage]}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{cursor:"pointer"}} onClick={() => { setShowPassword(!showPassword) }}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Box sx={{ paddingTop:"10px",paddingBottom:"5px"}}>
                    <Box sx={{display:"flex", gap:"10px", alignItems:"center"}}>
                      <Box
                        sx={{
                          width:["21px", "26px"],
                          height:["21px", "26px"],
                          cursor:"pointer",
                          backgroundImage:values?.checkRules === false ? "" : `url(${rectBlackCheckWhite})`,
                          backgroundSize:"contain",
                          backgroundRepeat:"no-repeat",
                          backgroundPosition:"center center",
                          border: values?.checkRules === false ? "1px solid black" : "0px",
                        }}
                        onClick={() => {
                          setFieldValue("checkRules", !values.checkRules)
                        }}
                      />
                      <Box sx={{
                        fontSize:"15px",
                        textAlign:"center",
                        color : "text.black",
                      }}>
                        {languageValues?.registerPage?.ruTexte[actLanguage]}
                        <Link component={RouterLink} sx={{marginLeft:"2px"}} onClick={() => {
                          if (actLanguage === "fr") {
                            window.open(window.location.origin+"/terms_FR", "_blank")
                          } else {
                            window.open(window.location.origin+"/terms_EN", "_blank")
                          }
                        }}>
                          {languageValues?.registerPage?.ruTitle[actLanguage]}
                        </Link>
                      </Box>
                    </Box>
                    <FormControl error={Boolean(touched.checkRules && errors.checkRules)}>
                      <FormHelperText>{touched.checkRules && errors.checkRules}</FormHelperText>
                    </FormControl>
                  </Box>
                  <Box sx={{ py: 2 }}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      {languageValues?.continue[actLanguage]}
                    </Button>
                  </Box>
                  {alertMessage && alertMessage.length > 0 && (
                    <Box
                      sx={{
                        pb: 1,
                        pt: 0
                      }}
                    >
                      <Typography
                        align="center"
                        color="red"
                        variant="body1"
                      >
                        {alertMessage}
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{
                    marginTop:"15px",
                    marginBottom:"15px",
                    fontSize:"16px",
                    textAlign:"center",
                    color : "text.primary",
                  }}>
                    {languageValues?.loginPage?.alreadyAccount[actLanguage]}
                    <Link component={RouterLink} to="/login" sx={{marginLeft:"3px"}}>
                      {languageValues?.mainLayout?.itsHere[actLanguage]}
                    </Link>
                  </Box>
                </form>
              )}
            </Formik>
          </Container>
        }

        {!isValidRequest &&
          <Container maxWidth="sm">
            <Box sx={{textAlign:"center", fontSize:"30px"}}>
              {languageValues?.notifError[actLanguage]}
            </Box>
          </Container>
        }

        <MyMiniModal
          isOpen={showModal}
          onClose={reject}
          title={languageValues?.registerPage?.confirmDialog?.title[actLanguage]}
          subTitle={languageValues?.registerPage?.confirmDialog?.subTitle[actLanguage]}
        >
          <Box sx={{
            display:"flex",
            justifyContent:"center",
          }}>
            <Button
              color="primary"
              size="large"
              type="submit"
              variant="contained"
              onClick={resolve}
            >
              {languageValues?.continue[actLanguage]}
            </Button>
          </Box>
        </MyMiniModal>
      </Box>
    </>
  );
};

export default RegisterAdmin;
